import { $Q } from "../utils/query-selector";
import { dataToggle } from "../utils/toggle-dataset";

/**
 * It changes input type
 * @param {HTMLElement} input : It is thei input
 * @param {Boolean} active : If the input is active or not
 */
const changeInputType = (input, active) => {
  active
   ? input.type = 'password'
   : input.type = 'text'
}

/**
 * It toggles type
 */
export const togglePassword = () => {
  const icon = $Q('.form__password');
  const input = $Q('#RegisterForm-password');

  if(!icon || !input) return;

  icon.addEventListener('click', () => {
    const { dataset } = icon;
    changeInputType(input, dataset.active === 'true');
    dataToggle(icon);
  })
}
